import script from "./RegisteringI18nPreviousTreatments.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegisteringI18nPreviousTreatments.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__